
// ----------------------------------------------------------------------

export default function Logo() {
  return (
    // <img style={{ height: '60px', width: 'auto' }} src={process.env.PUBLIC_URL + '/images/logo.png'} />
    <img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="User" width={180} />
  );
}
